import { toString } from './common'
import { getLocalStorage } from './storage'

import { checkIfAdAccountRelatedLink, getCurrentRoute, redirectTo, updateRouteParams } from './url'

import { ROUTE_PARAMS, ROUTES } from '../constants/routes'
import { SELECTED_PARTNERSHIP_ID } from '../modules/actions/partnerships'

export function getInitialPartnershipId(partnerships, partnershipFromPath) {
  const isPartnershipValid = selectedPartnership => {
    return !!partnerships.find(partnership => toString(partnership.id) === toString(selectedPartnership))
  }

  const isPathPartnershipValid = isPartnershipValid(partnershipFromPath)

  if (isPathPartnershipValid) {
    // path with correct partnership
    return partnershipFromPath
  } else {
    // path with not correct partnership parameter - redirect to correct
    const savedAccount = getLocalStorage(SELECTED_PARTNERSHIP_ID)
    const isSavedSelfAccountValid = savedAccount && isPartnershipValid(toString(savedAccount))
    const validPartnershipId = isSavedSelfAccountValid ? savedAccount : partnerships[0] && partnerships[0].id

    updateRouteParams({
      [ROUTE_PARAMS.partnership]: toString(validPartnershipId)
    })
    return toString(validPartnershipId)
  }
}

// after changing selectedPartnership URLs should be updated
// keepUserOnCurrentPage used for manual force preventing of redirections
export function updatePartnershipUrl(selectedPartnershipData, keepUserOnCurrentPage) {
  const currentRoute = getCurrentRoute()

  const isAdAccountRelatedPath = checkIfAdAccountRelatedLink(currentRoute)
  const isRightsSummaryPage = currentRoute.includes('rights')

  if (isAdAccountRelatedPath && !keepUserOnCurrentPage) {
    // when path is AdAccount related(campaignSummary,LineItemSummary, and etc..) -> redirect to /campaigns
    redirectTo(ROUTES.campaigns, { [ROUTE_PARAMS.partnership]: toString(selectedPartnershipData.id) })
  } else if (isRightsSummaryPage && !keepUserOnCurrentPage) {
    // when change on rights summary page - redirect to partnerships page
    redirectTo(ROUTES.partnerships, { [ROUTE_PARAMS.partnership]: toString(selectedPartnershipData.id) })
  } else {
    // all other pages just update the id in URL and fetch new data related on partnership and it's subfields(adAccounts for different platform and etc..)
    updateRouteParams({
      [ROUTE_PARAMS.partnership]: toString(selectedPartnershipData.id)
    })
  }
}
